import React, { useState, useEffect } from 'react';
import Button from 'react-bootstrap/Button'
import Popup from './Popup/Popupformbootstrap';
import { Helmet, HelmetProvider } from 'react-helmet-async';

function ResultDetail(props) {
    
    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const [paramdata, setParamdata] = useState({
        title: ''
    })

    useEffect(() => {
        setParamdata({
            title:props.match.params.testParam
        })
    },[])

    return (
        <div className="detailblk">
            <HelmetProvider>
                <Helmet>
                    <title>{paramdata.title}</title>
                    <meta name="description" content={paramdata.title} />
                    <meta property="og:url" content="https://www.huggies.com/en-us" />
                    <meta property="og:title" content={paramdata.title} />
                    <meta property="og:image" content="https://img.freepik.com/free-photo/portrait-asia-baby-white-bed_39704-2231.jpg" />
                </Helmet>
            </HelmetProvider>
            Third Route - {props.match.params.testParam}
            <h2>{props.match.params.testParam}</h2>
            <div className="sharelinks">
                <div className="linkblk">
                    <div className="favoriteblk">
                        <Button variant="secondary">Favorite</Button>
                    </div>
                    <div className="psharelinks">
                        <Button variant="primary" onClick={handleShow}>Mail</Button>
                        {/* <Button variant="secondary" onClick={fbshare}>Facebook</Button> */}                        
                        {/* Your FB Share & Like button code */}
                        <div className="fb-like" 
                            data-href="https://www.huggies.com/en-us" 
                            data-width=""
                            data-layout="button" 
                            data-action="like" 
                            data-size="large"  
                            data-share="true">
                        </div>

                         {/* <iframe 
                            style={iframestyles} 
                            src="https://www.facebook.com/plugins/like.php?href=https%3A%2F%2Fdevelopers.facebook.com%2Fdocs%2Fplugins%2F&width=450&layout=standard&action=like&size=small&share=true&height=35&appId" 
                            width="450" 
                            height="35"
                            scrolling="no" 
                            frameBorder="0" 
                            allowTransparency="true" 
                            allow="encrypted-media">                            
                        </iframe> */}
                    </div>
                </div>
                <div className="hintblk">
                    <p>Age: <span>Pregnancy</span></p>
                    <p>Execution Time: <span>Less than 1 hour</span></p>
                </div>
            </div>
            <div className="recipeimgblk">
                <img src="" />
            </div>
            <div className="recipedesc">
                <h5>Introduce</h5>
                <p>
                    Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. 
                </p>
                <h5>Resources</h5>
                <ul>
                    <li>Lorem ipsum dolor</li>
                    <li>sit amet</li>
                    <li>consectetur adipiscing</li>
                    <li>elit</li>
                    <li>sed do</li>
                </ul>
                <h5>Tutorial</h5>
                <p>
                    Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.
                </p>
            </div>
            <div className="keywordblk">
                <p>
                    Related Keywords: 
                    <span>Carrot Porridge</span>
                    <span>Pregnant</span>
                </p>
            </div>
            { 
                show ?
                    <Popup
                        show={show}
                        text='Click "Close Button" to hide popup'
                        handleClose={handleClose}
                    />
                : null
            }
        </div>        
    );
}

export default ResultDetail;